import { Checkbox } from '@design-system';
import { useTranslation } from 'next-i18next';

export type PreOrderOptInProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export const PreOrderOptIn = ({ checked, onChange }: PreOrderOptInProps) => {
  const { t } = useTranslation('checkout');

  return (
    <div className="flex flex-col gap-3 rounded-sm bg-verified-1 p-4">
      <div className="flex flex-col gap-1">
        <p className="font-bold">{t('details.preOrder.title')}</p>
        <p>{t('details.preOrder.description')}</p>
      </div>

      <Checkbox
        checked={checked}
        id="details-pre-order-opt-in"
        label={t('details.preOrder.label')}
        name="details-pre-order-opt-in"
        onChange={(e) => onChange(e.currentTarget.checked)}
        type="checkbox"
      />
    </div>
  );
};
